import { useMemo } from "react";
import { useAssetsConfigContext } from "@hooks/use-config-context/asset";
import { useTicketConfigContext } from "@hooks/use-config-context/ticket";
import { useUserConfigContext } from "@hooks/use-config-context/user";

export enum DataSource {
  ASSETS = "assets",
  TICKETS = "tickets",
  USERS = "users",
}

export const mapDbTableToDataSource = (
  dbTable?: string | null
): DataSource | null => {
  switch (dbTable?.toLowerCase()) {
    case "assets":
      return DataSource.ASSETS;
    case "tickets":
      return DataSource.TICKETS;
    case "users":
      return DataSource.USERS;
    default:
      return null;
  }
};

/**
 * Maps a dbTable string to the postType parameter for the aggregate API
 */
export const mapDbTableToPostType = (
  dbTable?: string | null
): 'asset' | 'ticket' | 'user' => {
  switch (dbTable?.toLowerCase()) {
    case "tickets":
      return "ticket";
    case "users":
      return "user";
    case "assets":
    default:
      return "asset";
  }
};

export const useDataSourceConfig = (
  dataSource: DataSource | null | undefined
) => {
  const assetConfig = useAssetsConfigContext();
  const ticketConfig = useTicketConfigContext();
  const userConfig = useUserConfigContext();

  return useMemo(() => {
    switch (dataSource) {
      case DataSource.TICKETS:
        return {
          tableColumns: ticketConfig.tableColumns as any[],
          fieldConfigs: ticketConfig.config,
        };

      case DataSource.USERS:
        return {
          tableColumns: userConfig.tableColumns as any[],
          fieldConfigs: userConfig.config,
        };

      case DataSource.ASSETS:
      default:
        return {
          tableColumns: assetConfig.tableColumns as any[],
          fieldConfigs: assetConfig.config,
        };
    }
  }, [assetConfig.config, assetConfig.tableColumns, dataSource, ticketConfig.config, ticketConfig.tableColumns, userConfig.config, userConfig.tableColumns]);
};